import { reatomAsync, withDataAtom } from '@reatom/async';
import { BACKEND_API } from '@trwl/backend.api';

export const referrerNameAction = reatomAsync(
  async (ctx, referrerId: number | undefined) => {
    if (!referrerId) return null;
    return BACKEND_API.AuthApi.getUsernameById(referrerId).then(
      ({ data }) => data,
    );
  },
  'referrerName',
).pipe(withDataAtom(null));
